module.exports = __webpack_public_path__ + "static/media/reroRero.39bcf588.gif";